<template>
    <div class="container" :style="{ backgroundImage: 'url(' + imgUrl + ')' }">
        <div class="box">
            <h3 class="title reveal-bottom">{{ $t("csa.t") }}</h3>
            <p class="text reveal-bottom">
                {{ $t("csa.c") }}
            </p>
            <div class="img1 reveal-bottom">
                <img
                    style="width:1200px;"
                    :src="
                        require('@/assets/img_svg/cloud_saas_acceleration_img_1.png')
                    "
                    alt="svg"
                />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            imgUrl: require("@/assets/images/cloud_saas_acceleration_banner_bg.jpg"),
        };
    },
};
</script>
<style scoped>
.container {
    height: 1030px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;
}
.box {
    width: 1200px;
    margin: auto;
    padding: 0 10px;
    box-sizing: border-box;
}
.title {
    font-size: 44px;
    color: #fff;
    letter-spacing: 0;
    line-height: 66px;
    margin-top: 150px;
}
.text {
    font-size: 22px;
    color: #fff;
    line-height: 44px;
    margin-top: 41px;
}
.img {
    width: 1180px;
    height: 447px;
    margin-bottom: 187px;
}
.img1 {
    width: 1180px;
    height: 447px;
    margin-top: 95px;
    margin-bottom: 187px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/CloudSaasAccerlation/Content0.vue